import React from 'react';
import { Form, Col } from "react-bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FaSearch, FaFilter, FaBullhorn, FaUsers, FaBus, FaShuttleVan, FaUserGraduate, FaCalendarCheck, FaUndo, FaPaperPlane, FaFileUpload } from 'react-icons/fa';
import Switch from '../../../components/Switch/Switch';
import Loader from '../../../components/Loader/Loader';
import Select from '../../../components/Select/Select';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import './NotificationForm.css';

const MODE_OF_TRANSPORT_OPTIONS = [
  { id: 'bus', name: 'Bus' },
  { id: 'van', name: 'Van' },
];

const PARENT_APP_STATUS_OPTIONS = [
  { id: '1', name: 'Activated' },
  { id: '0', name: 'Inactivated' },
];

const today = new Date().toISOString().split('T')[0];

const TransportBadge = ({ mode }) => {
  if (!mode) return '-';
  return (
    <span className={`transport-badge transport-badge-${mode}`}>
      {mode === 'bus' ? <FaBus /> : <FaShuttleVan />} {mode}
    </span>
  );
};

const NotificationForm = ({ isBulk, bulkChangeHandler, changeHandler, submitHandler, selectAllStudent, id,
  programData, notice, program_id, mode_of_transport, is_activated, vehicle_number, vehicleNumberSearchHandler,
  attendance_date, attendance_status, attendanceStatusOptions, isAttendanceFilter,
  resetFilters, isAnyFilterActive,
  isClassDisabled, isTransportFilterDisabled, isAttendanceFilterDisabled,
  studentList, student_ids, handleInputChange, student_loader, availableplaceholders
}) => {

  return (
    <Form onSubmit={submitHandler}>
      <div className="row">
        {/* placeholders */}
        {availableplaceholders?.length > 0 && (
          <Col xs={12}>
            <div className="notification-placeholder-box">
              <strong className="mb-2 text-muted d-block">Use these placeholders in notification to auto-fill student info:</strong>
              <div className="d-flex flex-wrap gap-2 mt-2">
                {availableplaceholders.map((ph, i) => (
                  <code key={i} className="notification-placeholder-chip">{ph}</code>
                ))}
              </div>
            </div>
          </Col>
        )}
        {!isBulk &&
          <Col xs={12}>
            <div className="notification-section-card">
              <div className="notification-section-heading">
                <span className="notification-section-icon"><FaBullhorn /></span>
                <span>Notice</span>
              </div>
              <CKEditor
                editor={ClassicEditor}
                data={notice}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  changeHandler({ target: { name: 'notice', value: data } });
                }}
              />
            </div>
          </Col>
        }
        {id ? "" : <Col xs={12}>
          <div className="notification-section-card notification-filter-card">
            <div className="notification-section-heading justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <span className="notification-section-icon"><FaFilter /></span>
                <span>Filter Students</span>
              </div>
              <Button
                variant="outline-secondary"
                type="button"
                size="sm"
                icon={<FaUndo />}
                disabled={!isAnyFilterActive}
                onClick={resetFilters}
              >
                Reset Filters
              </Button>
            </div>
            <div className="notification-filter-group">
              <div className="notification-filter-group-label">
                <FaUserGraduate /> <span>Filter by Class or Transport</span>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <Select
                    label="Class"
                    name="program_id"
                    value={program_id}
                    onChangeHandler={changeHandler}
                    options={programData}
                    placeholder="Select Class"
                    disabled={isClassDisabled}
                  />
                </div>
                <div className="col-md-3">
                  <Select
                    label="Mode of Transport"
                    name="mode_of_transport"
                    value={mode_of_transport}
                    onChangeHandler={changeHandler}
                    options={MODE_OF_TRANSPORT_OPTIONS}
                    placeholder="Select Mode of Transport"
                    disabled={isTransportFilterDisabled}
                  />
                </div>
                {mode_of_transport === "bus" &&
                  <div className="col-md-3">
                    <Input
                      label="Route Number"
                      name="vehicle_number"
                      value={vehicle_number}
                      onChangeHandler={changeHandler}
                      onKeyDown={vehicleNumberSearchHandler}
                      placeholder="Enter Bus Route Number"
                      disabled={isTransportFilterDisabled}
                    />
                  </div>
                }
                <div className="col-md-3">
                  <Select
                    label="Parent App Status"
                    name="is_activated"
                    value={is_activated}
                    onChangeHandler={changeHandler}
                    options={PARENT_APP_STATUS_OPTIONS}
                    placeholder="Select Status"
                    disabled={isTransportFilterDisabled}
                  />
                </div>
                <div className="col-md-3">
                  <label className="mb-1 mt-1 fw-semibold d-block invisible">Search</label>
                  <Button
                    variant="primary"
                    type="button"
                    className="w-100"
                    icon={<FaSearch />}
                    disabled={isTransportFilterDisabled}
                    onClick={vehicleNumberSearchHandler}
                  >
                    Search
                  </Button>
                </div>
              </div>
            </div>
            <div className="notification-filter-group notification-filter-group-divider">
              <div className="notification-filter-group-label">
                <FaCalendarCheck /> <span>Or filter by Attendance</span>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <Input
                    type="date"
                    label="Attendance Date"
                    name="attendance_date"
                    value={attendance_date}
                    onChangeHandler={changeHandler}
                    max={today}
                    disabled={isAttendanceFilterDisabled}
                  />
                </div>
                <div className="col-md-3">
                  <Select
                    label="Attendance Status"
                    name="attendance_status"
                    value={attendance_status}
                    onChangeHandler={changeHandler}
                    options={attendanceStatusOptions}
                    placeholder="Select Status"
                    disabled={isAttendanceFilterDisabled || !attendance_date}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end notification-filter-group-divider">
              <Button variant="primary" icon={<FaFileUpload />} onClick={bulkChangeHandler}>
                {isBulk ? "Manual Create" : "Bulk Upload"}
              </Button>
            </div>
          </div>
        </Col>
        }
        {!isBulk &&
          <React.Fragment>
            <Col xs={12}>
              <div className="notification-section-card">
                <div className="notification-section-heading justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <span className="notification-section-icon"><FaUsers /></span>
                    <span>Select Students</span>
                  </div>
                  <span className="notification-count-badge">
                    {student_ids.length} / {studentList ? studentList.length : 0} selected
                  </span>
                </div>
                {
                  student_loader ?
                    <Loader />
                    :
                    <Form.Group>
                      <div className="notification-table-wrap">
                        <table className="table table-hover table-bordered">
                          <thead>
                            <tr>
                              <th>SrNo</th>
                              <th>Roll No</th>
                              <th>Admission No</th>
                              <th>Name</th>
                              {!program_id && !isAttendanceFilter && <th>Mode of Transport</th>}
                              {!program_id && !isAttendanceFilter && <th>Route</th>}
                              {!program_id && !isAttendanceFilter && <th>Parent App Status</th>}
                              {isAttendanceFilter && <th>Class</th>}
                              <th>
                                <Switch
                                  checked={Boolean(studentList) && studentList.length > 0 &&
                                    student_ids.length === studentList.length}
                                  name="all"
                                  id="select-all"
                                  value="1"
                                  onChange={e => selectAllStudent(e)}
                                  label={'Select All'}
                                />
                              </th>
                            </tr>
                          </thead>
                          <tbody className="col-md-12">
                            {
                              studentList && studentList.map((student, index) =>
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{student.roll_no}</td>
                                  <td>{student.id_number}</td>
                                  <td>{student.first_name + " " + student.last_name}</td>
                                  {!program_id && !isAttendanceFilter && <td><TransportBadge mode={student.mode_of_transport} /></td>}
                                  {!program_id && !isAttendanceFilter && <td>{student.vehicle_number || '-'}</td>}
                                  {!program_id && !isAttendanceFilter &&
                                    <td>
                                      {student.is_activated !== undefined && student.is_activated !== null ? (
                                        <span
                                          className={`student-badge ${Number(student.is_activated) === 1
                                            ? "student-badge-active"
                                            : "student-badge-inactive"
                                            }`}
                                        >
                                          {Number(student.is_activated) === 1 ? "Activated" : "Inactivated"}
                                        </span>
                                      ) : '-'}
                                    </td>
                                  }
                                  {isAttendanceFilter && <td>{student.class_name || '-'}</td>}
                                  <td>
                                    <div className="form-check form-check-inline">
                                      {student_ids.length &&
                                        student_ids.indexOf(student.id.toString()) !== -1 ?
                                        <Switch
                                          name="student_id"
                                          id={student.id}
                                          checked={student_ids.indexOf(student.id.toString()) !== -1 ? true : false}
                                          value={student.id || ''}
                                          onChange={handleInputChange}
                                        /> :
                                        <Switch
                                          name="student_id"
                                          id={student.id}
                                          value={student.id || ''}
                                          onChange={handleInputChange}
                                        />
                                      }
                                    </div>
                                  </td>
                                </tr>)}
                            {!studentList || studentList.length === 0 ?
                              <tr>
                                <td colSpan={program_id ? 5 : isAttendanceFilter ? 6 : 8} className="notification-empty-state">
                                  <span><FaUserGraduate /> No Record Found</span>
                                </td>
                              </tr> : null}
                          </tbody>
                        </table>
                      </div>
                    </Form.Group>}
              </div>
            </Col>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="primary" type="submit" icon={<FaPaperPlane />}>
                Submit
              </Button>
            </div>
          </React.Fragment>
        }
      </div>
    </Form>);
};
export default NotificationForm;
